import React from 'react';
import {
  Box,
  CircularProgress,
  Typography,
} from '@mui/material';
import { AccountBalance as MosqueIcon } from '@mui/icons-material';

const LoadingScreen = ({ message = "Loading...", fullScreen = true }) => {

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        p: 4,
      }}
    >
      {/* Brand Icon */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: { xs: 60, sm: 80 },
          height: { xs: 60, sm: 80 },
          borderRadius: '50%',
          backgroundColor: 'primary.main',
          color: 'primary.contrastText',
          mb: 2,
          animation: 'pulse 2s infinite',
          '@keyframes pulse': {
            '0%': {
              transform: 'scale(1)',
              opacity: 1,
            },
            '50%': {
              transform: 'scale(1.05)',
              opacity: 0.8,
            },
            '100%': {
              transform: 'scale(1)',
              opacity: 1,
            },
          },
        }}
      >
        <MosqueIcon sx={{ fontSize: { xs: 30, sm: 40 } }} />
      </Box>

      {/* Loading Spinner */}
      <CircularProgress 
        size={40}
        thickness={4}
        sx={{
          color: 'primary.main',
        }}
      />

      {/* Loading Message */}
      <Typography
        variant="body1"
        color="text.secondary"
        align="center"
        sx={{
          fontWeight: 500,
          fontSize: { xs: '0.875rem', sm: '1rem' },
        }}
      >
        {message}
      </Typography>

      {/* Brand Text */}
      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
        sx={{
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
          mt: 2,
        }}
      >
        Pilgrim Information Management System
      </Typography>
    </Box>
  );

  if (fullScreen) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'background.default',
          zIndex: 9999,
        }}
      >
        {content}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {content}
    </Box>
  );
};

export default LoadingScreen;